// extracted by mini-css-extract-plugin
export default {"addToCartControl":"h1-z","giftCard":"i1-z","btnContainer":"j1-z","cartButton":"k1-z","disabled":"l1-z"};